import { create } from 'zustand';

import { authSDK } from '@services/oauth';
import { authSdk } from '@services/auth.service';
import ResponseCodes from '@constants/response.codes';
import { Role, RolePermission } from '@app-types/user.type';

type State = {
    oauthToken?: string;
    accessToken?: string;
    user?: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
    };
    permissions: RolePermission[];
    role?: Role;

    login: (user: any) => void;
    logout: () => void;
    fetchOAuthToken: (scopes?: string[]) => Promise<void>;
    fetchSession: () => Promise<void>;
};

export const useAuthStore = create<State>((set, get) => ({
    oauthToken: undefined,
    accessToken: localStorage.getItem('accessToken') ?? undefined,
    user:
        localStorage.getItem('user') &&
        JSON.parse(localStorage.getItem('user')!),
    role: undefined,
    permissions: [],

    login: (user: any) => {
        set({
            user,
            role: { id: user.role.id, name: user.role.name },
            permissions: user.role.permissions,
            accessToken: user.accessToken,
        });
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('accessToken', user.accessToken);
    },
    logout: () => {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        set({
            user: undefined,
            accessToken: undefined,
            role: undefined,
            permissions: [],
        });
    },
    fetchOAuthToken: async (scopes) => {
        const oauthToken = await authSDK.generateToken(scopes);
        oauthToken && set({ oauthToken });
    },
    fetchSession: async () => {
        const token = get().accessToken;
        if (!token) return;

        const response = await authSdk.getMyProfile(token);
        if (response.code !== ResponseCodes.PROCESS_OK) return;
        const { role } = response.data;
        set({
            user: response.data,
            role: { id: role.id, name: role.name },
            permissions: role.permissions,
        });
    },
}));
